import Image from 'next/image';
import React from 'react';
import { loader } from '../../../public/assets/icons';
import styles from './button.module.scss';
// import styles from "../../elements/button/button.module.scss"

const Button = ({
  type,
  label,
  onClick,
  onMouseOver,
  disabled,
  loading,
  className,
  btnIcon,
  textStyle,
}) => {
  return (
    <button
      type={type || 'button'}
      onClick={onClick}
      onMouseOver={onMouseOver}
      disabled={loading || disabled}
      className={[styles.btn, className].join(' ')}
      style={
        loading || disabled
          ? { cursor: 'not-allowed', background: 'var(--neutral-mid)' }
          : null
      }
    >
      {loading ? (
        <div className={styles.loading__container}>
          <div>
            {(
              <Image
                src={loader}
                height={40}
                width={40}
                alt="Stakecut | One stop Affiliate Marketplace"
              />
            ) || 'icon'}
          </div>
        </div>
      ) : (
        <div className={styles.btn__icon__container}>
          {/* look at mr-3 for fault */}
          {btnIcon && (
            <span className="mr-3 flex items-center justify-center">
                <Image
                  src={btnIcon}
                  alt="Stakecut | One stop Affiliate Marketplace"
                />
            </span>
          )}
          <div style={{ marginRight: 0, fontSize: textStyle }}>
            {label || 'Button Text'}
          </div>
        </div>
      )}
    </button>
  );
};

export default Button;


// import React, { useState } from 'react';
// // import styles from './password-reset.module.scss';
// import styles from "../../widgets/password-reset/password-reset.module.scss"
// import Link from 'next/link';

// // import Button from '../../elements/button';
// import Button from './Button';
// import Card from '../../elements/card';
// import Heading, { SmallText, Subheading } from '../../elements/text';
// import Input from '../../elements/input';
// import Image from 'next/image';
// import { leftArrow } from '../../../assets/icons';
// import { passwordResetValidationSchema } from '../../../utils';

// import { Formik, ErrorMessage } from 'formik';
// import { toast } from 'react-toastify';
// import { resetPassword } from '../../../api-client/reset-password';

// const Security = () => {
//   const [loading, setLoading] = useState(false);
//   return (
//     <>
//       <div className={[styles.arrow, 'container mt-8'].join(' ')}>
//         <Image src={leftArrow} alt="stakecut left arrow" />
//       </div>
//       <section  className='flex justify-center items-center'>
//         <div className="mx-auto my-2 w-full  ">
//         <p className='text-[#061938] leading-[20px] lg:text-[20px] text-[14px]  font-bold lg:my-8 my-4'>Email Address</p>
//             {/* <header>
//               <Heading >
//               <p className="mb-3 text-left  font-[600] text-[#061938] lg:text-[40px] text-[25px] leading-[43px]">
                
//                 Reset Password
//                 </p>
//                 </Heading>
//               <Subheading
                
//                 style={{ marginBottom: '8px' }}
//               >
//             <p className='text-left mt-2 lg:text-[18px] text-[14px] lg:leading-[20.3px] '>

//                 {
//                   'Enter email associated with your account and we’ll send an email with instructions to reset your password.'
//                 }
// </p>
//               </Subheading>
//             </header> */}
//             <Formik
//               // Initialise Initial Form Values
//               initialValues={{ email: '' }}
//               // Function for Error message Display
//               validationSchema={passwordResetValidationSchema}
//               // Submit Function
//               onSubmit={async data => {
//                 setLoading(true);
//                 try {
//                   const res = await resetPassword(data);

//                   toast.success(res.data.message);
//                   setLoading(false);
//                 } catch (error) {
//                   toast.error(error.response.data.message);
//                   setLoading(false);
//                 }
//               }}
//             >
//               {({ values, handleChange, handleSubmit, errors, touched }) => (
//                 <form
//                   onSubmit={e => {
//                     e.preventDefault();
//                     handleSubmit();
//                   }}
//                   className='flex items-center '
//                 >
                  
             
//                   <Input
//                     type="email"
//                     placeholder="Email"
//                     className={[styles.input, 'my-4 '].join(' ')}
//                     onChange={handleChange}
//                     error={errors.email && touched.email}
//                     value={values.email}
//                     name="email"
//                   />
//                   <ErrorMessage name="email">
//                     {msg => (
//                       <SmallText>
//                         <p className="error-text mb-4">{msg}</p>
//                       </SmallText>
//                     )}
//                   </ErrorMessage>
//                   <Button
//                     className="btn-primary py-9 lg:text-[20px] text-[14px] px-4 mt-7  lg:w-[140px]  w-full h-[42px] whitespace-nowrap"
//                     label="Reset Password"
//                     type="submit"
//                     loading={loading}
//                   />
//                 </form>
//               )}
//             </Formik>
        
//         </div>
//       </section>
//     </>
//   );
// };
// export default Security;
